import { lang } from 'app/config/language'
import { i18n } from 'i18n'
import { makeAutoObservable, runInAction } from 'mobx'
import { ImageStore } from 'page/tryon/store/ImageStore'
import { PoweredOptions } from 'page/tryon/store/PoweredOptions'
import { api } from 'store/api'
import { mx } from 'store/base/mx'
import { Inference } from 'type/Inference'
import { Product } from 'type/Product'

export class TryOnPageStore {
  readonly inference_id: string | undefined
  readonly product_id: string | undefined

  error: string | undefined
  loaded: boolean = false

  product: Product = {}
  footer!: PoweredOptions

  inference!: Inference
  images: ImageStore[] = []

  constructor(inference_id: string | undefined) {
    makeAutoObservable(this)
    this.inference_id = inference_id
    this.product_id = new URLSearchParams(location.search).get('product') || undefined
    void this.load()
  }

  get ready() {
    return this.loaded && this.images.every(image => image.state !== 'none')
  }

  get show_name(): boolean {
    const { lang, hide_name_for_en } = this.product
    const hide = lang === 'en' && hide_name_for_en
    return !hide
  }

  private async load() {
    const { inference_id, product_id } = this
    if (!inference_id) {
      runInAction(() => this.error = i18n('error.PageNotFound'))
      return
    }
    try {
      const _inference = api.getInference(inference_id)
      const _product = product_id ? api.getProduct(product_id) : undefined

      const product: Product = await _product ?? {}

      lang.lang = product.lang || 'ru'
      document.documentElement.classList.toggle('tsum', !!product.tsum)

      const inference = await _inference
      const { images } = inference

      runInAction(() => {
        this.product = product
        this.footer = PoweredOptions.fromProduct(product)

        this.inference = inference
        this.images = images.map(image => new ImageStore(image))

        this.loaded = true
      })
    } catch (e) {
      console.error('load failed', e)
      runInAction(() => this.error = i18n('error.PageNotFound'))
    }
  }
}

export const store = mx.ref<TryOnPageStore>()
